import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { ListOption } from '../components/connects/connects-interface';


@Injectable({
  providedIn: 'root'
})
export class DataServiceService {
isauth$= new BehaviorSubject<boolean>(false);
 private readonly listOption = new BehaviorSubject<ListOption>({searchName:'',page:1,size:5});
  listOption$ = this.listOption.asObservable();
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() { }
  setListOptionUpdate(listOption:ListOption){
    this.listOption.next(listOption);
  }
setAuthStatus(value:boolean){
  this.isauth$.next(value); }
}
